import IntegrationID from '@/constants/integrations/IntegrationID';
import { I18nStrong } from '@/modules/I18n';

/**
 * Returns a source enum to be used with donation summaries.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export default function getEntitySource(entity: any) {
  let source = '';

  if (Object.keys(entity?.classy || {}).length) {
    source = IntegrationID.CLASSY;
  }

  if (entity?.importMeta?.pledgeTransaction) {
    source = IntegrationID.PLEDGE;
  }

  if (entity?.importMeta?.stripeTransaction) {
    source = IntegrationID.STRIPE;
  }

  if (entity?.extSource === IntegrationID.EVENTBRITE) {
    source = IntegrationID.EVENTBRITE;
  }

  if (entity?.extSource === IntegrationID.SALESFORCE) {
    source = IntegrationID.SALESFORCE;
  }

  // no-op, return any empty string so the translation select statement can act
  // on it.
  return {
    source,
    strong: I18nStrong,
  };
}
